<template>
  <div class="Pagination">
    <el-pagination
      background
      layout="prev, pager, next"
      :total="total"
      :page="page"
      :page-size="pageSize"
      :prev-text="$t('上一頁')"
      :next-text="$t('下一頁')"
      @current-change="pageChange"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  props: {
    total: {
      type: Number,
      default: 50,
    },
    page: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {};
  },
  methods: {
    pageChange(val) {
      this.$emit("repeater", val);
    },
  },
};
</script>
<style lang="scss" scoped>
.Pagination {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}
::v-deep .el-pager li {
  font-size: 16px;
  font-weight: 300;
  color: #acacaf;
  border: 1px solid #acacaf;
  height: 36px;
  width: 36px;
  line-height: 36px;
  @media only screen and (max-width: 900px) {
    width: 25px;
    height: 25px;
    line-height: 25px;
  }
}
::v-deep .el-pager li {
  @media only screen and (max-width: 900px) {
    line-height: 25px !important;
  }
}

::v-deep .el-pager li.active + li {
  border-left: 1px solid #acacaf;
}
::v-deep .el-pager {
  li {
    margin: 0 10px !important;
    @media only screen and (max-width: 900px) {
      margin: 0 3px !important;
    }
  }
  li:hover {
    color: #c6a86c !important;
    @media only screen and (max-width: 900px) {
      background-color: #c6a86c !important;
      color: #fff !important;
    }
  }
}
::v-deep .btn-prev {
  font-size: 16px;
  font-weight: 300;
  color: #acacaf;
  border: 1px solid #acacaf;
  height: 36px;
  // line-height: 36px;
  @media only screen and (max-width: 900px) {
    height: 23px;
    font-size: 12px;
    padding: 0 5px;
  }
  span {
    height: 36px;
    line-height: 36px;
    padding: 0 5px;
    @media only screen and (max-width: 900px) {
      padding: 0 5px;
      height: 25px;
      line-height: 25px;
    }
  }
}
::v-deep .btn-next {
  font-size: 16px;
  font-weight: 300;
  color: #acacaf;
  border: 1px solid #acacaf;
  height: 36px;
  // line-height: 36px;
  @media only screen and (max-width: 900px) {
    height: 25px;
    font-size: 12px;
  }
  span {
    height: 36px;
    line-height: 36px;
    padding: 0 5px;
    @media only screen and (max-width: 900px) {
      padding: 0 5px;
    }
  }
}
::v-deep .active {
  background-color: #c6a86c !important;
  color: #fff !important;
}
</style>
